import { render, staticRenderFns } from "./MapxusManageSettings.vue?vue&type=template&id=261c2ecc&scoped=true"
import script from "./MapxusManageSettings.vue?vue&type=script&lang=js"
export * from "./MapxusManageSettings.vue?vue&type=script&lang=js"
import style0 from "./MapxusManageSettings.vue?vue&type=style&index=0&id=261c2ecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c2ecc",
  null
  
)

export default component.exports